<script>
    import { flags_json } from '$lib/static/flags_json.js'
    import { tooltip } from '$lib/app/tooltip.js';
    import { get_region_by_id } from '$lib/app/static.js';


    let {
        reg = undefined,
        force_unp = false,
        width = "1.8em",
        height = "0.9em",
        template = "%s"     // Optional tooltip template parameter, eg. "From: %s"
    } = $props();

    let flagURL = $derived(getFlagURL(reg, force_unp));

    // Disable the shadow for Nepali flag because it does not play well with its complex form
    let border = $derived(flagURL && reg != 'NP');

    let tooltipText = $derived.by(() => {
        const region = get_region_by_id(reg);
        return template.replace("%s", (region?.[3] || region?.[1] || ''));
    });

    function getFlagURL(reg, force_unp) {
        if(!reg) return reg;

        let unp = reg.substring(0, 2);

        if(force_unp) return flags_json[unp];
        if(reg.startsWith('GB-1')) return flags_json['GB-ENG'];
        if(reg.startsWith('GB-2')) return flags_json['GB-SCT'];
        if(reg.startsWith('GB-3')) return flags_json['GB-WLS'];
        return flags_json[reg];
    }

</script>

{#if flagURL}
<span style="display: inline-block; height:{height}; width:{width} !important;" use:tooltip data-tooltip={tooltipText}>
    <img style="height:{height}; vertical-align: -0.1em;" class:flag-border={border} src={flagURL} alt={tooltipText}/>
</span>
{:else}
<span style="display: inline-block; height:{height}; width:0px !important;">
    <img style="height:{height}; vertical-align: -0.1em;" class:flag-border={border} src='/i/1x1.png' alt=''/>
</span>
{/if}

<style>
@media (prefers-color-scheme: light) {
    .flag-border {
        border-bottom: 0.5px solid #d8d8d8;
        border-right: 0.5px solid #d8d8d8;
    }
}
</style>


